// Version : 0.0.3
// Author : VISHNU
// LastEdit : Sabari
// Last ADD : Unwanted Redux Clear
// MODFIED DATE : 11-11-2025

import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	getChangeBranchOfficerDetailsFailure,
	getChangeBranchOfficerDetailsResponseChanged,
	getChangeBranchOfficerDetailsSuccess,
	getLoanGroupDetailsFailure,
	getLoanGroupDetailsResponseChanged,
	getLoanGroupDetailsSuccess,
	getOfficerCenterDetailsFailure,
	getOfficerCenterDetailsResponseChanged,
	getOfficerCenterDetailsSuccess,
	updateChangeGroupOfficerDetailsFailure,
	updateChangeGroupOfficerDetailsResponseChanged,
	updateChangeGroupOfficerDetailsSuccess,
} from './change-group-officer.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import ChangeGroupOfficerActionTypes from './change-group-officer.type';
import {
	branchOfficerListGet,
	ChangeGroupOfficerListUpdate,
	loanGroupListGet,
	officerCenterListGet,
	branchOfficerListGetAutoLoan,
	ChangeGroupOfficerListUpdateAutoLoan,
	loanGroupListGetAutoLoan,
	officerCenterListGetAutoLoan,
} from './change-group-officer.service';

/************* GET OFFICER CENTER LIST START *************/
export function* getOfficerCenterList({ payload }: any) {
	try {
		const key = 'GetOfficerCenterListKey';
		const { databaseName, officerID, branchID, loanType } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			OfficerID: officerID,
			AreaID: branchID,
			WhenToPay: '-',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			loanType === 'AutoLoan' ? officerCenterListGetAutoLoan : officerCenterListGet,
			encodeData,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getOfficerCenterDetailsFailure(responseData.data));
		} else {
			yield put(getOfficerCenterDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getOfficerCenterDetailsFailure(error));
	}
}

export function* resetGetOfficerCenterListResponse() {
	yield put(getOfficerCenterDetailsResponseChanged());
}

export function* onGetOfficerCenterListDetails() {
	yield takeLatest(
		ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_START,
		getOfficerCenterList,
	);
}

export function* onGetOfficerCenterListResponseReset() {
	yield takeLatest(
		ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_RESPONSE_RESET,
		resetGetOfficerCenterListResponse,
	);
}

/************* GET LOAN GROUP LIST START *************/
export function* getLoanGroupList({ payload }: any) {
	try {
		const key = 'GetLoanGroupListKey';
		const { databaseName, centerID, branchID, groupID, companyID, loanType } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CenterID: centerID,
			BranchID: branchID,
			GroupID: groupID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			loanType === 'AutoLoan' ? loanGroupListGetAutoLoan : loanGroupListGet,
			encodeData,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanGroupDetailsFailure(responseData.data));
		} else {
			yield put(getLoanGroupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanGroupDetailsFailure(error));
	}
}

export function* resetGetLoanGroupListResponse() {
	yield put(getLoanGroupDetailsResponseChanged());
}

export function* onGetLoanGroupListDetails() {
	yield takeLatest(ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_START, getLoanGroupList);
}

export function* onGetLoanGroupListResponseReset() {
	yield takeLatest(
		ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_RESPONSE_RESET,
		resetGetLoanGroupListResponse,
	);
}

/************* GET CHANGE BRANCH OFFICER LIST START *************/
export function* getChangeBranchOfficerList({ payload }: any) {
	try {
		const key = 'GetOfficerListBranchKey';
		const {
			companyID,
			branchID,
			centerID,
			databaseName,
			userID,
			userLevel,
			userRole,
			isNewOfficerAlso,
			loanType,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			isNewOfficerAlso: isNewOfficerAlso,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			loanType === 'AutoLoan' ? branchOfficerListGetAutoLoan : branchOfficerListGet,
			encodeData,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getChangeBranchOfficerDetailsFailure(responseData.data));
		} else {
			yield put(getChangeBranchOfficerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getChangeBranchOfficerDetailsFailure(error));
	}
}

export function* resetGetChangeBranchOfficerListResponse() {
	yield put(getChangeBranchOfficerDetailsResponseChanged());
}

export function* onGetChangeBranchOfficerListDetails() {
	yield takeLatest(
		ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_START,
		getChangeBranchOfficerList,
	);
}

export function* onGetChangeBranchOfficerListResponseReset() {
	yield takeLatest(
		ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_RESPONSE_RESET,
		resetGetChangeBranchOfficerListResponse,
	);
}
/************* GET CHANGE BRANCH OFFICER LIST END *************/

/************* UPDATE CHANGE GROUP OFFICER LIST START *************/
export function* updateChangeGroupOfficerList({ payload }: any) {
	try {
		const key = 'ChangeGroupOfficerKey';
		const {
			changeofficerID,
			ChangeGroupOfficerName,
			CompanyID,
			branchID,
			centerID,
			groupID,
			CurrentGroupOfficerID,
			CurrentGroupOfficerName,
			GroupName,
			CenterName,
			CreatedBy,
			changebranchID,
			changeForValue,
			DatabaseName,
			UserName,
			transferGroupList,
			loanType,
		} = payload;
		const transferGroupJsonList = JSON.stringify(transferGroupList).replace(/"/g, "'");
		const jsonData = {
			GroupOfficerID: changeofficerID,
			GroupOfficerName: ChangeGroupOfficerName,
			CompanyID: CompanyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			CurrentGroupOfficerID: CurrentGroupOfficerID,
			CurrentGroupOfficerName: CurrentGroupOfficerName,
			GroupName: GroupName,
			CenterName: CenterName,
			userID: CreatedBy,
			ChangeBranchID: changebranchID,
			isChangeOfficerOnlyLoanIndex: changeForValue,
			DatabaseName: DatabaseName,
			UserAccessBranchID: branchID,
			UserName: UserName,
			GroupLoanIndexArr: transferGroupJsonList,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			loanType === 'AutoLoan'
				? ChangeGroupOfficerListUpdateAutoLoan
				: ChangeGroupOfficerListUpdate,
			encodeData,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateChangeGroupOfficerDetailsFailure(responseData.data));
		} else {
			yield put(updateChangeGroupOfficerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateChangeGroupOfficerDetailsFailure(error));
	}
}

export function* resetUpdateChangeGroupOfficerListResponse() {
	yield put(updateChangeGroupOfficerDetailsResponseChanged());
}

export function* onUpdateChangeGroupOfficerListDetails() {
	yield takeLatest(
		ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_START,
		updateChangeGroupOfficerList,
	);
}

export function* onUpdateChangeGroupOfficerListResponseReset() {
	yield takeLatest(
		ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_RESPONSE_RESET,
		resetUpdateChangeGroupOfficerListResponse,
	);
}
/************* UPDATE CHANGE GROUP OFFICER LIST END *************/

/************* CHANGE GROUP OFFICER SAGA START *************/
export function* changeGroupOfficerSaga() {
	yield all([
		call(onGetOfficerCenterListDetails),
		call(onGetOfficerCenterListResponseReset),
		call(onGetLoanGroupListDetails),
		call(onGetLoanGroupListResponseReset),
		call(onGetChangeBranchOfficerListDetails),
		call(onGetChangeBranchOfficerListResponseReset),
		call(onUpdateChangeGroupOfficerListDetails),
		call(onUpdateChangeGroupOfficerListResponseReset),
	]);
}
/************* CHANGE GROUP OFFICER SAGA END *************/
